export default __webpack_public_path__ + "static/media/ranes6.4678ecdc.jpg";